import { AppConfig } from "../config/AppConfig";
import { getToken,logout } from "./userData";
import axios from "axios";
import { Base64 } from 'js-base64';
/**
 * ApiHelper Class - For making Api Requests
 */
let CancelToken = axios.CancelToken;
// eslint-disable-next-line
let cancel;

/**
 * ApiHelper Class - For making Api Requests
 */
let username = 'admin';
let password = '1234'

const token = `${username}:${password}`;
const encodedToken = Base64.encode(token);

const getHeaderToken = () => {
    return { 'Authorization': 'Basic ' + encodedToken };
}

const fetchFromServer = async (service,
    endpoint,
    authenticated = false,
    method,
    queryOptions = undefined, 
    body = undefined,
    isFormFormate = false,
    ) => {
    let url = AppConfig.API_ENDPOINT + service + endpoint;
//     let headers = {
//    //     'Authorization': 'Basic ' + encodedToken, 'Access-Control-Allow-Origin': '*',
//     //    'Content-Type': 'application/json',
//     'Content-Type': 'multipart/form-data',
//     //    'Access-Control-Allow-Origin': '*', 
//     };
    // if (authenticated) {
    //     // const storageSession = getToken();
    //     headers.token = storageSession;
    // }

    let headers = {
        'Content-Type': 'application/json',
        };

    if (isFormFormate) {
        headers = {
            'Content-Type': 'multipart/form-data',
            // 'Access-Control-Allow-Origin': '*'
        };
    }
    if (authenticated) {
        headers.token = localStorage.getItem("token");
    }
    queryOptions = { ...queryOptions };

    const response = await axios.request({
        method,
        url,
        headers: headers,
        maxBodyLength: Infinity,
        data: body,
        params: queryOptions,
    });
   
    if (parseInt(response.data.success)  === 5) {
        localStorage.removeItem("token");
        localStorage.removeItem("isLogin");
        localStorage.removeItem("userInfo");
         window.location.href = '/account/signin';
    }
    if (response.status === 200) {
        return {
            ...response.data,
            status: 1,
        }
    } else {
        return {
            ...response.data,
            status: 0,
        }
    }
}

export { fetchFromServer, getHeaderToken };
// export class ApiHelper {
//     _portalGateway;
//     _apiVersion;


//     constructor() {
//         this._portalGateway = AppConfig.API_ENDPOINT;
//         this._apiVersion = AppConfig.API_VERSION;
//     }
//     setHost = (host) => {
//         this._portalGateway = host;
//     };
//     setApiVersion = (version) => {
//         this._apiVersion = version;
//     };
//     /**
//      * Fetches from the Gateway defined by the instantiated object. Accepts <T> as output object.
//      * @example <caption>"/Auth/UserAccount", "/GetCurrentUser", "GET", "JWT Content"</caption>
//      * @param {service} service - wanting to be access ex. "UserAuth/Auth"
//      * @param {endpoint} endpoint - you wish to call ex. "/Login"
//      * @param {method} mehotd - method (GET, UPDATE, DELETE, POST)
//      * @param {jwt} JWT - JSON Web Token (Optional)
//      * @param {queryOptions} Query - query options for "GET" methods (Optional)
//      * @param {body} body - JSON body for "UPDATE, DELETE and POST" methods (Optional)
//      * @param {progressCallback} - To get the upload file progress events
//      */
//     async getMethodServer(
//         service,
//         endpoint,
//         authenticated = false,
//         queryOptions = undefined,
//     ) {
//         console.log("Test")
//         let url = this._portalGateway + service + endpoint;
//         let headers = { 'Authorization': 'Basic ' + encodedToken };
//         if (authenticated) {
//             const storageSession = getToken();
//             headers.token = storageSession;
//         }
//         queryOptions = { ...queryOptions };
//         await axios.get(url, {
//             headers: headers,
//             params: queryOptions,
//         })
//             .then((res) => console.log(res.data))
//             .catch((err) => console.error(err));
//     }

//     async FetchFromServer(
//         service,
//         endpoint,
//         method,
//         authenticated = false,
//         queryOptions = undefined,
//         body = undefined,
//         progressCallback = undefined
//     ) {
//         //let url = this._portalGateway + this._apiVersion + service + endpoint;
//         let url = this._portalGateway + service + endpoint;
//         let headers = { 'Authorization': 'Basic ' + encodedToken };
//         if (authenticated) {
//             const storageSession = getToken();
//             headers.token = storageSession;
//         }


//         queryOptions = { ...queryOptions };
//         body = { ...body };

//         try {
//             method = method.toLowerCase();
//             var response;
//             if (progressCallback) {
//                 response = await axios.request({
//                     method,
//                     url,
//                     data: body,
//                     headers: headers,
//                     params: queryOptions,
//                     onUploadProgress: progressCallback.onUploadProgress,
//                     cancelToken: new CancelToken(function executor(c) {
//                         cancel = c;
//                     }),
//                 });
//             } else {
//                 response = await axios.request({
//                     method,
//                     url,
//                     data: body,
//                     headers: headers,
//                     params: queryOptions,
//                 });
//             }

//             if (response.ok === false || response.status !== 200) {
//                 let errorObject = {
//                     code: response.status,
//                     data: response.data,
//                 };
//                 throw errorObject;
//             }
//             const data = new SuccessHandlerHelper(response?.data);
//             return data?.data;
//         } catch (err) {
//             const errorHelper = new ErrorHandlerHelper(err.response);
//             return errorHelper.error;
//         }
//     }

//     /**
//      * Cancels the last request.
//      */
//     cancelRequest = err => {
//         cancel && cancel(err);
//     };
// }
